import "../node_modules/.pnpm/vue@3.5.13_typescript@4.9.5/node_modules/vue/dist/vue.runtime.esm-bundler.es.js";
import { requestSlot } from "./HyperApp.es.js";
import { h, Comment } from "../node_modules/.pnpm/@vue_runtime-core@3.5.13/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.es.js";
let getVNode = () => h(Comment, "anchor");
const setupPortalSlot = (target) => {
  if (target === "vue2") {
    getVNode = () => h("div", []);
  }
};
const PortalSlot = (props, ctx) => {
  const slotAttrs = { ...ctx.attrs, ...props.scope };
  if (props.slot) {
    return props.slot(slotAttrs);
  }
  const renderCallback = requestSlot(props.componentId, props.name, slotAttrs);
  if (!renderCallback) {
    return ctx.slots.default ? ctx.slots.default() : [];
  }
  const vNode = getVNode();
  renderCallback({
    name: props.name || "default",
    // @ts-ignore
    getAnchor: () => vNode.el,
    // @ts-ignore
    getContainer: () => vNode.el.parentElement,
    attrs: slotAttrs
  });
  return vNode;
};
PortalSlot.props = {
  name: {
    type: String,
    default: "default"
  },
  componentId: {
    type: String
  },
  slot: {
    default: () => void 0
  },
  scope: {
    type: Object
  }
};
export {
  PortalSlot,
  setupPortalSlot
};
//# sourceMappingURL=PortalSlot.es.js.map
